import { Modal } from "react-easetools";
import { ConfirmDeleteUI } from "./ConfirmDeleteUI";

export const ConfirmDeleteModal = async (entityName: string) => {
    const m = await Modal({
      title: () => <></>,
      footer: null,
      props: {
        container: {
          className:"!dark:bg-gray-800 z-[100000]",
          style: {
            padding: 0,
          },
        },
        body: {
          className: "flex justify-center items-center",
          style: {
            padding: 0,
          },
        },
      },
      body: ({ close }: any) => (
        <ConfirmDeleteUI
          entityName={entityName}
          onCancel={() => {
            close({ data: false });
          }}
          onConfirm={() => {
            close({ data: true });
          }}
        />
      ),
    });
    
    return m;
};